var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.02 35.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c0c0c;}.cls-2,.cls-3{fill:#505050;}.cls-3{stroke:#505050;stroke-miterlimit:10;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.51,
    cy: 17.51,
    r: 16.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.51,35A17.51,17.51,0,1,1,35,17.51,17.53,17.53,0,0,1,17.51,35Zm0-32.33A14.82,14.82,0,1,0,32.33,17.51,14.84,14.84,0,0,0,17.51,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.74,27.37v-1A5.18,5.18,0,0,0,23,21.39c0-2.47-1.43-5.11-5.49-5.11-2,0-3-.88-3-2.65a2.88,2.88,0,0,1,3-2.64,2.86,2.86,0,0,1,3,2.64,1.24,1.24,0,1,0,2.48,0,5.22,5.22,0,0,0-4.26-5v-1a1.23,1.23,0,1,0-2.46,0v1a5.21,5.21,0,0,0-4.26,5c0,2.5,1.43,5.11,5.49,5.11,2,0,3,.88,3,2.65a2.83,2.83,0,0,1-3,2.6,2.85,2.85,0,0,1-3-2.6,1.23,1.23,0,1,0-2.46,0,5.17,5.17,0,0,0,4.26,4.95v1a1.23,1.23,0,1,0,2.46,0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarDark);
export default __webpack_public_path__ + "static/media/dollar_dark.68b54b3779499e387b528fbd26193cc3.svg";
export { ForwardRef as ReactComponent };